import module from 'cliente/module.js'
import template from './template.html'

export class ClienteComponent {
  idCliente
  data = null

  constructor ($q, Cliente) {
    this.$q = $q
    this.Cliente = Cliente
  }

  $onInit () {
    this.promise = this.$q.all([
      this.Cliente.get(this.idCliente)
        .then(({data}) => (this.data = data)),
    ])
  }
}

module.component('clienteInicio', {
  controller: ClienteComponent,
  template,
  bindings: {
    idCliente: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/component.js